import React, { useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../../../redux/hooks';

// Components 

import Box from '@mui/material/Box';

type Props = {
    children?: React.ReactNode,
    title: string
};

const Section: React.FC<Props> = ({ children, title }) => {

  const { t } = useTranslation(); 
  const dispatch = useAppDispatch(); 

  const colors = useAppSelector(state => state.theme.colors);

  return (

    <Box
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        width: '95%',
        marginTop: 5,
        fontSize: 14,
      }}>

      <Box
        sx={{ 
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%',
          fontSize: 16,
          marginBottom: 4, 
        }}
      >{t(title)}</Box>

      <Box
          sx={{
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            padding: 2,
            borderRadius: 5,
            backgroundColor: colors?.patientDataSection, 
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',      
          }}
      >
          {children}

      </Box>
    </Box>

  );
};

export default Section;




















